/*
 * Wizard steps action types
 */

let nextid = 0;

export const CREATE_STEP = 'CREATE_STEP';
export const TOGGLE_VALID_STEP = 'TOGGLE_VALID_STEP';
export const CURRENT_STEP = 'CURRENT_STEP';
export const NEXT_STEP = 'NEXT_STEP';
export const PREVIOUS_STEP = 'PREVIOUS_STEP';
export const ADD_CHILD_STEP = 'ADD_CHILD_STEP';

export const currentStep = (id) => ({
    type: CURRENT_STEP,
    id: `step_${id}`,
});

export const toggleValidStep = (id, valid) => ({
    type: TOGGLE_VALID_STEP,
    id,
    valid,
});

export const nextStep = (id) => ({
    type: NEXT_STEP,
    id: `step_${id}`,
});

export const previousStep = (id) => ({
    type: PREVIOUS_STEP,
    id: `step_${id}`,
});

// TODO don't create new step ids if read from localStorage
export const createStep = (step) => ({
    type: CREATE_STEP,
    id: (step.id || `step_${nextid+=1}`),
    name: step.name,
    current: step.current,
    active: step.active,
    completed: step.completed,
    parentId: step.parentId,
});

export const addChildStep = (id, childStepId) => ({
    type: ADD_CHILD_STEP,
    id,
    childStepId
});
